// src/features/coupon/services/userCouponService.ts

import api from '../../../api/axios';

import {
  USER_COUPON_ENDPOINTS,
} from '../../../api/endpoints/couponEndpoints';

import type {
  ApiResponse,
  UserCoupon,
} from '../types/coupon.types';


export const userCouponService = {

  /**
   * 내 전체 쿠폰함
   */
  async getMyCoupons():
    Promise<UserCoupon[]> {

    const response =
      await api.get<
        ApiResponse<UserCoupon[]>
      >(
        USER_COUPON_ENDPOINTS
          .MY_COUPONS,
      );

    return response.data.data;
  },


  /**
   * 사용 가능한 쿠폰
   */
  async getAvailableCoupons():
    Promise<UserCoupon[]> {

    const response =
      await api.get<
        ApiResponse<UserCoupon[]>
      >(
        USER_COUPON_ENDPOINTS
          .AVAILABLE,
      );

    return response.data.data;
  },


  /**
   * 내 쿠폰 단건
   */
  async getMyCoupon(
    userCouponId: number,
  ): Promise<UserCoupon> {

    const response =
      await api.get<
        ApiResponse<UserCoupon>
      >(
        USER_COUPON_ENDPOINTS
          .DETAIL(
            userCouponId,
          ),
      );

    return response.data.data;
  },


  /**
   * 쿠폰 직접 사용
   */
  async useCoupon(
    userCouponId: number,
  ): Promise<UserCoupon> {

    const response =
      await api.patch<
        ApiResponse<UserCoupon>
      >(
        USER_COUPON_ENDPOINTS
          .USE(
            userCouponId,
          ),
      );

    return response.data.data;
  },
};